<template>
    <div class="common-picker">
        <div
            class="common-picker-action"
            :class="!value ? 'with-placeholder' : ''"
            :style="{ 'line-height': !!actionHeight ? actionHeight : '' }"
            @click="toggleModal"
        >
            <div>{{ label || placeHolder }}</div>
            <div v-if="!readonly" class="ico-box">
                <img
                    :style="{ transform: `rotate(${iconRotate})` }"
                    src="../../../../assets/images/btn_next@2x.png"
                />
            </div>
        </div>
        <div v-if="showModal" class="common-picker-modal">
            <div class="common-picker-modal-mask" @click="toggleModal" />
            <div class="common-picker-modal-content">
                <div class="common-picker-modal-header">
                    <div>{{ title }}</div>
                    <div
                        class="common-picker-modal-close close-bg"
                        @click="toggleModal"
                    />
                </div>
                <div class="common-picker-modal-body">
                    <div class="select-list">
                        <template v-for="item in options">
                            <div
                                v-if="!item.invisible"
                                class="select-item"
                                @click="handleSelect(item)"
                            >
                                <span
                                    class="select-item_label"
                                    :class="{ checked: item.value === value }"
                                >
                                    {{ item.label }}
                                </span>
                                <img
                                    v-if="item.value === value"
                                    class="select-item_checked"
                                    src="https://cdn-app.nio.com/BEYONDER/2020/11/9/864df262-3c6d-42f6-9cda-c9e792e917ec.png"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        actionHeight: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '请选择'
        },
        placeHolder: {
            type: String,
            default: '请选择'
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showModal: false,
            label: ''
        };
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    const item = this.options.find(i => i.value === val);
                    this.label = (item && (item.label || item.value)) || val;
                }
            },
            immediate: true
        },
        options: {
            handler(val) {
                if (val) {
                    const item = val.find(i => i.value === this.value);
                    this.label =
                        (item && (item.label || item.value)) || this.value;
                }
            },
            immediate: true
        }
    },
    methods: {
        toggleModal() {
            this.showModal = this.readonly ? false : !this.showModal;
        },
        handleSelect(currentItem) {
            this.showModal = false;
            this.$emit('select', currentItem);
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';

.ico-box {
    width: 20 * @layout375;
    margin-left: 5 * @layout375;
    text-align: right;
    display: flex;
    align-items: center;
    img {
        width: 90%;
    }
}

.common-picker {
    display: block;
    width: 100%;

    &-action {
        width: 100%;
        color: #363c54;
        font-size: 16 * @layout375;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .with-placeholder {
        color: #cdced4;
    }

    &-modal {
        display: block;
        position: fixed;
        z-index: 200;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
        animation: 0.3s fadeIn;

        &-mask {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }
        &-content {
            display: flex;
            flex-direction: column;
            background: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            height: 50vh;
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
        }

        &-header {
            padding: 20 * @layout375 25 * @layout375;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 60 * @layout375;
            box-sizing: border-box;

            div {
                font-size: 16 * @layout375;
                font-weight: bold;
                color: #363c54;
                line-height: 20 * @layout375;
            }
        }
        &-close {
            width: 16 * @layout375;
            height: 16 * @layout375;
        }
        .close-bg {
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAG1BMVEVHcExpbn9ibHpqbYBqbX5mZoBpbYBobH5pbX8ZklvmAAAACHRSTlMAnBbUWQq8fwUtPhEAAACnSURBVDjL5dNNCsMgEAVghfxsC9m4zBl6iJBlyRVCDtAjFDdz7BqR8Y2+E7SuHOWDmSc69xfrjcX20u0sj3o+yKV7L596scuzFqGSQeLqGDEAiAVAGqCkBUo6UEgPCiEgEwYyoeAmFNyEg9QShuwwVgwZQQyUpJY8I3kGRvIMhJShe1KG7oim1BJNqSEQqyUQqyHmHZBMGKuHYjzxHRYoDuzk+KmP/AVZBzZ2i29QLQAAAABJRU5ErkJggg==);
            background-repeat: no-repeat;
            background-size: cover;
        }

        &-body {
            font-family: 'BlueSkyStandardRegular';
            overflow-y: auto;
            height: calc(~'100% - 16vw');
            box-sizing: border-box;
        }
    }
}

.select-list {
    padding: 0 25 * @layout375;
}
.select-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 18 * @layout375 0;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 5 * @layout375;
        right: 5 * @layout375;
        background-color: #ebecee;
        height: 1 * @layout375;
    }

    &:first-child::before {
        content: '';
        position: absolute;
        top: 0;
        left: 5 * @layout375;
        right: 5 * @layout375;
        background-color: #ebecee;
        height: 1 * @layout375;
    }

    &_label {
        font-size: 16 * @layout375;
        color: #363c54;
        &.checked {
            color: #00bebe;
        }
    }

    &_checked {
        position: absolute;
        right: 10 * @layout375;
        top: 50%;
        width: 20 * @layout375;
        height: 20 * @layout375;
        margin-top: -10 * @layout375;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/marketing_components/form/picker/common-picker/index.vue